// components/FloatingCartButton.js
import React, { useEffect } from "react";
import { Badge } from "@mui/material";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import Link from "next/link";
import { useRouter } from "next/router";

export default function FloatingCartButton({ cartCount, count, hidden = false }) {
  const router = useRouter();
  const effectiveCount = Number.isFinite(cartCount) ? cartCount : Number(count ?? 0);

  useEffect(() => {
    console.log("Cart Count:", effectiveCount);
  }, [effectiveCount]);

  if (hidden || effectiveCount <= 0) return null;

  return (
    <>
      <div className="cart_sec" onClick={() => router.push("/shop/cart")}>
        <Link href="/shop/cart">
          <Badge badgeContent={effectiveCount} color="primary">
            <ShoppingCartIcon />
          </Badge>
        </Link>
      </div>

      <style jsx>{`
        .cart_sec {
          position: fixed;
          background: linear-gradient(#ffa800, #ff7e00);
          color: #000000;
          border-radius: 40% 0 0 40%;
          box-shadow: -2px 4px 10px 1px #1e1e1ef2;
          top: 212px;
          z-index: 9;
          right: 0;
          padding: 15px 15px 10px 15px;
          cursor: pointer;
        }
        .cart_sec a { display: flex; align-items: center; justify-content: center; text-decoration: none; color: inherit; }
        .cart_sec :global(svg) { color: #000; }
        .cart_sec :global(.MuiBadge-badge) {
          position: absolute; background: #f0ff0c; color: #000; font-weight: 700; right: -2px;
        }
      `}</style>
    </>
  );
}
